import { render, staticRenderFns } from "./PFormSelectNarrow.vue?vue&type=template&id=0377ce8d&scoped=true&"
import script from "./PFormSelectNarrow.vue?vue&type=script&lang=ts&"
export * from "./PFormSelectNarrow.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelectNarrow.vue?vue&type=style&index=0&id=0377ce8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0377ce8d",
  null
  
)

export default component.exports